/**
 * media_note renderer（音声動画注釈・EP-2・M7b）。
 *
 * video/audio が「誌面に埋め込む」のに対し、media_note は誌面に**小さなマーカーを置き、
 * クリックでポップアップを開いて**中で再生する（「点で示して開く」形）。中身のプレーヤは
 * {@link createMediaPlayer} を再利用する。
 *
 * ポップアップは初回オープン時に 1 度だけ作り、以後は表示/非表示を切り替える
 * （iframe を作り直さない＝再生位置を保つ）。ページから外れたら閉じて一時停止する。
 * 作りは {@link markerPopupRenderer} に共通化してあり、video/audio の `display: 'popup'`
 * （T012・D178）も同じ描き手を使う。
 */
import type { OverlayRenderer } from '../registry';
import { createMediaPlayer } from './media';
import { markerPopupRenderer } from './popup';

/** video/audio をポップアップの中で再生する描き手（閉じると一時停止する）。 */
export function mediaPopupRenderer(kind: 'video' | 'audio'): OverlayRenderer {
  return markerPopupRenderer({
    markerClass: 'overlay-note',
    labelKey: 'overlay.note.open',
    fill: (stage, item, context) => {
      const player = createMediaPlayer(stage, item, context, kind);
      return () => player?.pause();
    },
  });
}

const videoPopup = mediaPopupRenderer('video');
const audioPopup = mediaPopupRenderer('audio');

export const mediaNoteRenderer: OverlayRenderer = (el, item, context) =>
  (item.payload['kind'] === 'audio' ? audioPopup : videoPopup)(el, item, context);
